// extracted by mini-css-extract-plugin
export default {"modalContent":"_l-z"};